import React from 'react';
import { AffiliateStore, MarketingTools } from '../../../shared/Link';
import { HeaderCollapsible } from '../index';

export const ResourcesCollapsible = () => (
  <HeaderCollapsible title="affiliates_signup_perseus.header.resources">
    <MarketingTools variant="subitem" />
    <AffiliateStore variant="subitem" />
  </HeaderCollapsible>
);
